// extracted by mini-css-extract-plugin
module.exports = {"container":"Center_container__0XWzV","textCentered":"Center_textCentered__qjOuM"};